import { Link } from "react-router-dom";
import { Button } from "@/components/wensity/button";

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-lg space-y-4 py-16 text-center">
      <p className="font-mono text-sm uppercase tracking-[0.2em] text-[var(--color-primary)]">404</p>
      <h1 className="text-3xl font-semibold">Page not found</h1>
      <p className="text-[var(--color-muted)]">That route doesn&apos;t exist in this rewrite yet.</p>
      <Button asChild variant="brand">
        <Link to="/">Back home</Link>
      </Button>
    </div>
  );
}
